import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WarehouseRequest, WarehouseResponse } from '../models/warehouse.model';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getWarehouseByClue(clue: any) {
    return this.http.get(this.url + "api/erp/inventory/warehouse/search/existing", {
      params: {
        clue: clue
      }
    });
  }

  getWarehouses() {
    return this.http.get(this.url + "api/erp/inventory/warehouse");
  }

  getCategoryWarehouses() {
    return this.http.get(this.url + "api/erp/inventory/warehouse/categories");
  }

  activeOrInactiveWarehouse(id: number) {
    return this.http.delete(this.url + "api/erp/inventory/warehouse/" + id);
  }

  getDepartmentsByCountry(id: number) {
    return this.http.get(this.url + "api/country/" + id + "/department");
  }

  getTownsByDepartment(idDepartment: number, idCountry: number) {
    return this.http.get(this.url + "api/country/" + idCountry + "/department/" + idDepartment + "/town");
  }

  getCountry() {
    return this.http.get(this.url + "api/country");
  }

  postWarehouse(newWarehouse: WarehouseRequest) {
    return this.http.post(this.url + "api/erp/inventory/warehouse", newWarehouse);
  }

  putWarehouse(newWarehouse: WarehouseRequest, warehouseId: number) {
    return this.http.put(this.url + `api/erp/inventory/warehouse/${warehouseId}`, newWarehouse);
  }

  getWarehousesAllowedByUser(userId: number) {
    return this.http.get(this.url + `api/erp/inventory/warehouse/allowedByUser`, {
      params: {
        user: userId
      }
    });
  }

  getWarehousesAllowedByUserAndCylinder(userId: number) {
    return this.http.get(this.url + `api/erp/inventory/warehouse/allowedByUser/cylinders`, {
      params: {
        user: userId
      }
    });
  }

}
